module.exports = __webpack_public_path__ + "static/media/search.9118c52b.svg";